<template>
  <modal
    name="editSecaoRodape"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="true"
  >
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="row">
          <ul class="tabs">
            <li class="tab-active">
              <a v-if="!item._id">Criar Seção</a>
              <a v-else>
                Editando Seção:
                <span style="font-weight: 200">{{ item.descricao }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="form">
          <div class="row">
            <div class="col-1-2">
              <div class="form-group">
                <label for>Descrição</label>
                <input
                  type="text"
                  v-model="item.descricao"
                  class="form-control"
                />
                <div class="message">
                  {{ validation.firstError('item.descricao') }}
                </div>
              </div>
            </div>

            <div class="col-1-2">
              <div class="form-group">
                <label for>Ordem</label>
                <input
                  type="number"
                  v-model="item.ordem"
                  class="form-control"
                />
                <div class="message">
                  {{ validation.firstError('item.ordem') }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-actions">
              <button
                :class="{
                  'button button-success button-lg': true,
                  'button-disabled': validation.hasError(),
                }"
                v-on:click="handleSubmit"
              >
                Alterar
              </button>
              <button class="button button-lg" v-on:click="close">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
  name: 'editaSecaoRodape',
  props: ['item', 'close', 'editorFunction', 'onSuccess'],
  data() {
    return {};
  },
  methods: {
    handleSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.editorFunction(this.onSuccess);
        }
      });
    },
  },

  validators: {
    'item.ordem': function (value) {
      return Validator.value(value).required().digit();
    },
    'item.descricao': function (value) {
      return Validator.value(value).required();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/SecoesRodape/Edit.vue